import { DEFAULT_ISD_CODE } from "constants/phoneConfig";

const getIsdCodeFromMapping = (item) => {
  const isdCodes = item?.isd_codes ?? item?.isdCodes;

  if (!Array.isArray(isdCodes) || isdCodes.length === 0) {
    return "";
  }

  const firstIsd = isdCodes[0];
  if (typeof firstIsd === "string") {
    return firstIsd.trim();
  }

  return String(firstIsd?.code ?? "").trim();
};

export const normalizeCountryMappings = (items = []) =>
  items
    .map((item) => {
      const countryCode = String(item?.code ?? "").trim();
      const isdCode = getIsdCodeFromMapping(item);

      if (!countryCode || !isdCode) {
        return null;
      }

      return {
        countryId: item.id,
        countryCode,
        countryName: item.display_name || item.displayName || item.name || countryCode,
        isdCode,
      };
    })
    .filter(Boolean);

export const getDefaultCountry = (
  countries = [],
  preferredIsd = DEFAULT_ISD_CODE
) => {
  if (!countries.length) {
    return null;
  }

  const byIsd = countries.find((country) => country.isdCode === preferredIsd);
  if (byIsd) {
    return byIsd;
  }

  return countries[0];
};

export const getCountryByCode = (countries = [], countryCode) => {
  if (!countryCode) {
    return null;
  }

  return (
    countries.find((country) => country.countryCode === countryCode) || null
  );
};

export const toCountrySelectOptions = (countries = []) =>
  countries.map((country) => ({
    value: country.countryCode,
    label: `${country.countryCode} ${country.isdCode}`,
  }));
